export default {
  GET_SK_PAGE: (state, data) => {
    state.satuanKerja = data;
  },
  GET_TOTAL_DATA: (state, data) => {
    state.total = data;
  },
};
